import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import FormTextarea, { ENTER } from '../../../../atoms/FormTextarea/FormTextarea'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import InfoLabel from '../../../../atoms/InfoLabel/InfoLabel'
import { Edit, Plus } from '../../../../atoms/NewIcons'
import { api } from '../../../../../utils/index'
import NewModal from '../../../../molecules/NewModal/NewModal'
import {
  MODALITA_SPEDIZIONE,
  PORTI,
  PROFILOAZIENDA,
  VETTORI,
  INDIRIZZI,
} from '../../../../../utils/endpoint'
import { useSelector } from 'react-redux'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import useTrans from '../../../../../hooks/useTrans'
import { trackingCheckoutShipping } from '../../../../../utils/gtm'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import * as Sentry from '@sentry/browser'

const FormIndirizzoSipec = dynamic(() => import('../../../MyAccount/FormIndirizzo/FormIndirizzo'))
const FormIndirizzoSg = dynamic(() => import('../../../MyAccount/FormIndirizzoSg/FormIndirizzoSg'))

const IndirizzoSpedizione = ({
  setStep,
  step,
  props,
  service_gift,
  carrello_main,
  handleScroll,
}) => {
  const { utente } = useSelector((state) => state.utente)
  const t = useTrans()
  const router = useRouter()

  const [selectedIndirizzo, setSelectedIndirizzo] = useState(
    props.values.indirizzo && props.values.indirizzo
  )
  const [loading, setLoading] = useState(false)
  const [porti, setPorti] = useState([])
  const [opzioniCorriere, setOpzioniCorriere] = useState([])
  const [Indirizzo, setIndirizzo] = useState()
  const [indirizzo_sede, setIndirizzoSede] = useState()
  const [show, setShow] = useState(false)
  const [tipoSpedizione, setTipoSpedizione] = useState(
    service_gift?.attivo ? 'corriere_sipec' : props.values.tipo_spedizione
  )
  const [mioCorriere, setMioCorriere] = useState(
    props.values.tipo_spedizione !== 'Spedizione' &&
      props.values.tipo_spedizione !== 'corriere_sipec' &&
      true
  )
  const [indirizzi, setIndirizzi] = useState([])
  const [altroCorriere, setAltroCorriere] = useState(null)

  const FormIndirizzo = service_gift ? FormIndirizzoSg : FormIndirizzoSipec

  const _fetchIndirizzi = async (id) => {
    await api.get(INDIRIZZI).then((res) => {
      const indirizziData = res.data ? [...res.data.filter((x) => !x.is_fatturazione)] : []

      const editedIndirizzo = indirizziData?.filter((item) => item?.id === id)?.[0]

      setIndirizzi(indirizziData)
      !selectedIndirizzo &&
        setSelectedIndirizzo(
          indirizziData.filter((item, i) => item.preferenziale === true)?.[0] ||
            indirizziData.filter((item, i) => item.is_sede === true)?.[0]
        )

      id &&
        editedIndirizzo?.email &&
        props?.setFieldValue('email_spedizione', editedIndirizzo?.email)
      id && setSelectedIndirizzo(editedIndirizzo)
      setLoading(false)
    })
  }
  useEffect(async () => {
    setLoading(true)
    !props.values?.email_spedizione && _preloadEmail()
    service_gift?.attivo &&
      (props.setFieldValue('tipo_spedizione', 'corriere_sipec'),
      props.setFieldValue('documento_trasporto', 'ts'))

    _fetchIndirizzi()

    api
      .get(PORTI, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => setPorti(res.data.sort((a, b) => b?.id - a?.id)))
    api
      .get(VETTORI, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => setOpzioniCorriere(res.data))
    api
      .get('profilo-azienda/current-user/')
      .then((res) => setIndirizzoSede(res.data?.indirizzo_sede))
      .catch((err) => {
        console.log(err)
        Sentry.captureException(err)
      })
    _handleServiceGift()
  }, [])

  const _refetchModal = () => {
    // Soluzione per selezionare nuovi indirizzi creati anche se non preferenziali
    api.get(INDIRIZZI).then((res) => {
      const indirizziData = res.data ? [...res.data.filter((x) => !x.is_fatturazione)] : []

      const isEdit = indirizzi?.length === indirizziData?.length

      setIndirizzi(indirizziData)

      !isEdit && setSelectedIndirizzo(indirizziData[indirizziData?.length - 1])
      !isEdit &&
        props.setFieldValue('email_spedizione', indirizziData?.[indirizziData?.length - 1]?.email)

      !selectedIndirizzo &&
        setSelectedIndirizzo(
          indirizziData.filter((item, i) => item.preferenziale === true)?.[0] ||
            indirizziData.filter((item, i) => item.is_sede === true)?.[0]
        )
    })
  }

  useEffect(() => {
    tipoSpedizione === 'Altro' && setAltroCorriere('')
    tipoSpedizione && props.setFieldValue('tipo_spedizione', tipoSpedizione)
  }, [tipoSpedizione])

  useEffect(() => {
    service_gift?.attivo ? setTipoSpedizione('corriere_sipec') : setTipoSpedizione()
    selectedIndirizzo && props.setFieldValue('indirizzo', selectedIndirizzo)
    selectedIndirizzo && selectedIndirizzo?.nazione?.codice !== 'IT' && setMioCorriere(null)
    selectedIndirizzo && !props.values?.porto_id && _preloadPorto()
  }, [selectedIndirizzo])

  useEffect(() => {}, [indirizzi])

  // ! Viene chiamata alla chiusura del Form
  const _onClose = async (id) => {
    await _fetchIndirizzi(id)
  }

  const _handleServiceGift = () => {
    if (service_gift) {
      api
        .get(MODALITA_SPEDIZIONE, {
          params: {
            lang: router.locale,
          },
        })
        .then((res) =>
          props.setFieldValue(
            'tipo_spedizione_id',
            res.data.filter((tipo) => tipo.modalita === 'Spedizione')[0]?.id
          )
        )
      api
        .get(PORTI, {
          params: {
            lang: router.locale,
          },
        })
        .then((res) =>
          props.setFieldValue(
            'porto_id',
            res.data?.filter((porto) => porto.modalita === 'porto_franco')[0]?.id
          )
        )
    }
  }

  // ! Verrà chiamata solo nel primo inserimento, nel caso di Edit si lasceranno i dati inseriti dall utente
  const _preloadPorto = () => {
    const result = porti.filter((porto) => porto.id === selectedIndirizzo?.porto_id)
    if (result.length > 0) {
      const porto = result[0]
      _setPorto(porto)
    } else {
      api.get(PROFILOAZIENDA).then((res) => {
        const profilo_azienda_indirizzo = res.data.indirizzo
        const result_azienda = porti.filter(
          (porto) => porto.id === profilo_azienda_indirizzo?.porto_id
        )
        profilo_azienda_indirizzo &&
          profilo_azienda_indirizzo?.porto_id &&
          result_azienda.length > 0 &&
          _setPorto(result_azienda[0])
      })
    }
  }
  // ? viene chiamata per settare il porto nei casi di preselezione
  const _setPorto = (porto) => {
    const fromItaly = selectedIndirizzo?.nazione?.codice === 'IT'
    props.setFieldValue('vettore_id', undefined)
    props.setFieldValue('porto_id', porto.id)
    fromItaly
      ? setTipoSpedizione(porto.modalita === 'porto_assegnato' ? null : porto.modalita)
      : setTipoSpedizione(porto.modalita)
    fromItaly
      ? setMioCorriere(porto.modalita === 'porto_franco' ? false : true)
      : setMioCorriere(false)
    props.setFieldValue('altro_vettore', undefined)
  }

  const _preloadEmail = () => {
    if (selectedIndirizzo?.email) {
      props.setFieldValue('email_spedizione', selectedIndirizzo?.email)

      return selectedIndirizzo?.email
    } else {
      props.setFieldValue('email_spedizione', indirizzo_sede ? indirizzo_sede : utente?.email)

      return indirizzo_sede?.email ? indirizzo_sede?.email : utente?.email
    }
  }

  return loading ? (
    <LoadingSvg />
  ) : (
    <>
      <div className="checkout__spedizione">
        <div className="checkout__section">
          <p className="checkout__section-title">{t('I tuoi indirizzi')}</p>
          <FormField className="checkout__formfield">
            {indirizzi &&
              indirizzi.map((indirizzo, index) => (
                <div
                  className={
                    'checkout__option checkout__option--indirizzo' +
                    (selectedIndirizzo && selectedIndirizzo.id === indirizzo.id
                      ? ' checkout__option--selected'
                      : '')
                  }
                  key={index}
                >
                  <FormRadio
                    name="indirizzo"
                    value={indirizzo.id}
                    checked={selectedIndirizzo && selectedIndirizzo.id === indirizzo.id}
                    onClick={() => {
                      setSelectedIndirizzo(indirizzo)
                      indirizzo?.email && props.setFieldValue('email_spedizione', indirizzo?.email)
                    }}
                    label={
                      <>
                        <strong>{indirizzo.ragione_sociale}</strong>
                        <p>
                          {indirizzo.indirizzo +
                            ' ' +
                            indirizzo.citta +
                            ' ' +
                            indirizzo.cap +
                            ' ' +
                            indirizzo.nazione?.nome}
                        </p>
                      </>
                    }
                  />
                  {!indirizzo.is_sede && (
                    <Button
                      onClick={() => {
                        setIndirizzo(indirizzo)
                        setShow(true)
                      }}
                      label={t('Modifica indirizzo')}
                      variant="ghost"
                      size="small"
                      icon={<Edit />}
                      icon_pos="left"
                    />
                  )}
                </div>
              ))}

            <Button
              variant="ghost"
              size="medium"
              label={t('Aggiungi un nuovo indirizzo')}
              icon={<Plus />}
              icon_pos="left"
              onClick={() => {
                setIndirizzo(null)
                setShow(true)
              }}
            />
          </FormField>

          <FormField
            label={t('E-mail per avviso della spedizione')}
            status={
              props.touched.email_spedizione
                ? props.errors.email_spedizione
                  ? 'error'
                  : null
                : null
            }
            errorMessage={props.touched.email_spedizione && props.errors.email_spedizione}
            className="checkout__formfield"
          >
            <FormInput
              onBlur={props.handleBlur('email_spedizione')}
              placeholder={t('Email per avviso spedizione')}
              value={
                props.values.email_spedizione === null || undefined
                  ? _preloadEmail()
                  : props.values.email_spedizione
              }
              onChange={(e) => props.setFieldValue('email_spedizione', e.target.value)}
            />
          </FormField>
          <FormField label={t('Note Spedizione')} className="checkout__formfield">
            <FormTextarea
              placeholder={t("Inserisci informazioni relative all'ordine - Note Spedizione")}
              value={props.values.note_spedizione}
              onChange={(e) => props.setFieldValue('note_spedizione', e.target.value)}
              preventKeys={[ENTER]}
            />
          </FormField>
        </div>

        {!service_gift && (
          <>
            <div className="checkout__section">
              <p className="checkout__section-title">{t('Tipo di spedizione')}</p>
              <FormField className="checkout__formfield">
                {porti &&
                  porti.map((porto) => (
                    <div
                      key={porto.id}
                      className={
                        'checkout__option' +
                        (tipoSpedizione === porto.modalita ? ' checkout__option--selected' : '')
                      }
                    >
                      <FormRadio
                        checked={
                          mioCorriere
                            ? selectedIndirizzo?.nazione?.codice === 'IT' &&
                              porto?.modalita !== 'porto_franco'
                              ? true
                              : false
                            : tipoSpedizione === porto?.modalita
                        }
                        label={
                          porto.modalita === 'porto_franco' ? (
                            <InfoLabel
                              label={t('Spedizione con corriere Sipec ed addebito in fattura')}
                              tooltipLabel={t(
                                'Il trasporto sarà effettuato dai corrieri di Sipec e ti verrà addebitato in fattura'
                              )}
                              tooltipPos="bottom"
                              className="info-label__icon-wrapper"
                            />
                          ) : (
                            t('Spedizione con mio corriere in porto assegnato')
                          )
                        }
                        onClick={() => {
                          const fromItaly = selectedIndirizzo?.nazione?.codice === 'IT'
                          props.setFieldValue('vettore_id', undefined)
                          props.setFieldValue('porto_id', porto.id)
                          fromItaly
                            ? setTipoSpedizione(
                                porto.modalita === 'porto_assegnato' ? null : porto.modalita
                              )
                            : setTipoSpedizione(porto.modalita)
                          fromItaly
                            ? setMioCorriere(porto.modalita === 'porto_franco' ? false : true)
                            : setMioCorriere(false)
                          props.setFieldValue('altro_vettore', undefined)
                        }}
                      />
                    </div>
                  ))}
              </FormField>
            </div>
            {mioCorriere && (
              <>
                <div className="checkout__section">
                  <p className="checkout__section-title">{t("Selezione un'opzione")}</p>
                  <FormField className="checkout__formfield">
                    {opzioniCorriere &&
                      opzioniCorriere.map((opzione) => (
                        <div
                          className={
                            'checkout__option' +
                            (opzione.descrizione === tipoSpedizione
                              ? ' checkout__option--selected'
                              : '')
                          }
                          key={opzione.id}
                        >
                          <FormRadio
                            label={opzione.descrizione}
                            checked={opzione.descrizione === tipoSpedizione}
                            onClick={() => {
                              setAltroCorriere(null)
                              setTipoSpedizione(opzione.descrizione)
                              props.setFieldValue('vettore_id', opzione.id)
                              props.setFieldValue('altro_vettore', undefined)
                            }}
                          />
                        </div>
                      ))}
                    <div
                      className={
                        'checkout__option' +
                        (tipoSpedizione === 'mio_corriere' ? ' checkout__option--selected' : '')
                      }
                    >
                      <FormRadio
                        label={t('Mio corriere: mi occupo io di prenotare il ritiro')}
                        checked={tipoSpedizione === 'mio_corriere'}
                        onClick={() => {
                          setAltroCorriere(true)
                          setTipoSpedizione('mio_corriere')
                        }}
                      />
                    </div>
                  </FormField>
                  {altroCorriere !== null && (
                    <div className="checkout__spedizione__altrocorriere">
                      <FormField label={t('Note sul corriere (Facoltativo)')}>
                        <FormInput
                          placeholder={t('inserisci il nome del corriere che effettuerà il ritiro')}
                          onChange={(e) => props.setFieldValue('altro_vettore', e.target.value)}
                        />
                      </FormField>
                      <Button
                        label={t('Conferma')}
                        variant="secondary"
                        size="medium"
                        onClick={() => setAltroCorriere(null)}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}

        {
          <Button
            disabled={
              tipoSpedizione &&
              props.values.tipo_spedizione !== 'Spedizione' &&
              selectedIndirizzo &&
              props.values.indirizzo &&
              !props.errors.email_spedizione
                ? false
                : true
            }
            label={t('Conferma indirizzo')}
            variant="primary"
            size="medium"
            onClick={() => {
              setStep(step + 1)
              handleScroll()
              trackingCheckoutShipping(
                carrello_main,
                mioCorriere ? 'shipping_my_courier' : 'shipping_with_sipec'
              )
            }}
          />
        }
      </div>
      <NewModal
        visible={show}
        onClose={() => setShow(false)}
        title={Indirizzo ? t('Modifica indirizzo') : t('Aggiungi un nuovo indirizzo')}
      >
        <div className="form__indirizzo__wrapper">
          <FormIndirizzo
            refetchModal={_refetchModal}
            onClose={(id) => _onClose(id)}
            setVisible={setShow}
            isModal={true}
            editIndirizzo={Indirizzo}
          />
        </div>
      </NewModal>
    </>
  )
}

export default IndirizzoSpedizione
